import { GeoMultiPolygon, GeoPolygon } from "@mapmycustomers/shared/types/shapes";
import AreaRegion from "@mapmycustomers/shared/types/territory/AreaRegion";
import AreaType from "@mapmycustomers/shared/types/territory/AreaType";

import getBoundaryUrl from "@app/scene/map/utils/getBoundaryUrl";

const generateShape = async (
  areaType: AreaType,
  regionIds: AreaRegion["id"][]
): Promise<GeoMultiPolygon | GeoPolygon> =>
  new Promise((resolve, reject) => {
    fetch(getBoundaryUrl("shape"), {
      body: JSON.stringify({
        areaType,
        selectedRegionIds: regionIds,
        // zoom: 0,
        // viewport: [-180, -90, 180, 90], // entire world
      }),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    })
      .then(async (response) => {
        const text = await response.text();
        if (response.status !== 200 && response.status !== 201) {
          throw new Error(text);
        }
        if (!text.length) {
          throw new Error("there was nothing to merge");
        }
        return text;
      })
      .then((text) => {
        resolve(JSON.parse(text) as GeoMultiPolygon | GeoPolygon);
      })
      .catch(reject);
  });

export default generateShape;
